export const GET_CINEMAS = 'cinemas/allCinemas/get';
export const GET_CINEMA_BY_ID = 'cinemas/cinemaById/get';
export const GET_CINEMA_BY_SLUG = 'cinemas/cinemaBySlug/get';
export const GET_CINEMAS_WITH_DOLBY = 'cinemas/cinemaByDolby/get';
export const GET_CINEMA_GALICINOS = 'cinema/galicino/get'